const e = {
  name: "Play",
  dimensions: { width: 18, height: 20 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1355 8.24487C17.3754 9.03011 17.3754 10.8389 16.1355 11.6241L4.00451 19.3071C2.67287 20.1505 0.934406 19.1937 0.934406 17.6175V2.25153C0.934406 0.675293 2.67287 -0.281486 4.00451 0.561886L16.1355 8.24487ZM2.93441 17.6175L15.0654 9.93451L2.9344 2.25152L2.93441 17.6175Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Play
};
